module.exports = __webpack_public_path__ + "FixelDisplay-Medium.86b7ddde36d2f102b885.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-Medium.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-Medium.woff2
// module chunks = styles